import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SitePartsPage } from "src/components/views/erp/parts/siteParts/SitePartsPage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/parts")({
	staticData: { title: i18n.t("parts"), legacyViewKey: "sitePartPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <SitePartsPage isActive={isActive} />;
}
